import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import IntakePage from "@/pages/IntakePage";
import PaymentPage from "@/pages/PaymentPage";
import ErrorBoundary from "@/components/custom/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<IntakePage />} />
            <Route path="/payment/:intakeId" element={<PaymentPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </div>
    </ErrorBoundary>
  );
}

export default App;
